import {EntityType} from "../../../gd/const/item"
import ModelEntity from "../../model-entity"
import Task from "../../task/task"
import Meeting from "../../meeting/meeting"
import Document from "../../doc/document"
import Event from "../../event/event"
import ProjectSession from "../../project/project-session"
import User from "../../user/user"

// Builds the model for ONE endpoint of a relation from its compact entity JSON.
//
// The same json shape arrives on both paths (the GET payload's per-type buckets
// and the live relation event's inline endpoints), and its keys match the
// full-object field names -- so the real constructors accept it and yield a
// display-level stub (title / status / short id, no messages or subtasks).
//
// Null when there is nothing to build (deleted, no access, or a type we do not
// render); the collection drops such rows.
export function relationEntityFromJson(itemType: EntityType, json: any): ModelEntity | null {

    if (!json || !json.id) return null

    switch (itemType) {
        case EntityType.TASK    : return new Task(json)
        case EntityType.MEETING : return new Meeting(json)
        case EntityType.DOCUMENT: return new Document(json)
        case EntityType.EVENT   : return new Event(json)

        // Required lazily: goal.ts loads its own subclasses, which EXTEND it, so
        // a static import here would run them before Goal itself is defined.
        case EntityType.GOAL    : return new (require("../../goal/goal").default)(json)

        // Session-first: a summary-built ProjectSession / User is detached (no
        // settings, tree or access).
        case EntityType.PROJECT : return gd.session.projects.get(json.id) || new ProjectSession(json)
        case EntityType.USER    : return gd.session.users.get(json.id) || new User(json)

        default                 : return null
    }
}
